/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  MySupportedFleet,
  MySupporterContribution,
  MySupporterContributionsList,
  StandardError,
  SupporterClaimKey,
  SupporterNominationInput,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Show the supporter claim key
 */
export const mySupporterClaimKey = (

 signal?: AbortSignal
) => {


      return axiosClient<SupporterClaimKey>(
      {url: `/me/supporter/claim-key`, method: 'GET', signal
    },
      );
    }




export const getMySupporterClaimKeyQueryKey = () => {
    return [
    'me','supporter','claim-key'
    ] as const;
    }


export const getMySupporterClaimKeyQueryOptions = <TData = Awaited<ReturnType<typeof mySupporterClaimKey>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mySupporterClaimKey>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getMySupporterClaimKeyQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mySupporterClaimKey>>> = ({ signal }) => mySupporterClaimKey(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mySupporterClaimKey>>, TError, TData>
}

export type MySupporterClaimKeyQueryResult = NonNullable<Awaited<ReturnType<typeof mySupporterClaimKey>>>
export type MySupporterClaimKeyQueryError = ErrorType<StandardError>


/**
 * @summary Show the supporter claim key
 */

export function useMySupporterClaimKey<TData = Awaited<ReturnType<typeof mySupporterClaimKey>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mySupporterClaimKey>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMySupporterClaimKeyQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary List my supporter contributions
 */
export const mySupporterContributions = (

 signal?: AbortSignal
) => {


      return axiosClient<MySupporterContributionsList>(
      {url: `/me/supporter/contributions`, method: 'GET', signal
    },
      );
    }




export const getMySupporterContributionsQueryKey = () => {
    return [
    'me','supporter','contributions'
    ] as const;
    }


export const getMySupporterContributionsQueryOptions = <TData = Awaited<ReturnType<typeof mySupporterContributions>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mySupporterContributions>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getMySupporterContributionsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mySupporterContributions>>> = ({ signal }) => mySupporterContributions(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mySupporterContributions>>, TError, TData>
}

export type MySupporterContributionsQueryResult = NonNullable<Awaited<ReturnType<typeof mySupporterContributions>>>
export type MySupporterContributionsQueryError = ErrorType<StandardError>


/**
 * @summary List my supporter contributions
 */

export function useMySupporterContributions<TData = Awaited<ReturnType<typeof mySupporterContributions>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mySupporterContributions>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMySupporterContributionsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Nominate the fleet a contribution is for
 */
export const nominateFleetForSupporterContribution = (
    id: MaybeRefOrGetter<string>,
    supporterNominationInput: MaybeRefOrGetter<SupporterNominationInput>,
 signal?: AbortSignal
) => {
      id = toValue(id);
supporterNominationInput = toValue(supporterNominationInput);

      return axiosClient<MySupporterContribution>(
      {url: `/me/supporter/contributions/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: supporterNominationInput, signal
    },
      );
    }




export const getNominateFleetForSupporterContributionMutationKey = () => ['nominateFleetForSupporterContribution'] as const;

export const getNominateFleetForSupporterContributionMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof nominateFleetForSupporterContribution>>, TError,NominateFleetForSupporterContributionMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof nominateFleetForSupporterContribution>>, TError,NominateFleetForSupporterContributionMutationVariables, TContext> => {

const mutationKey = getNominateFleetForSupporterContributionMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof nominateFleetForSupporterContribution>>, NominateFleetForSupporterContributionMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  nominateFleetForSupporterContribution(id,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type NominateFleetForSupporterContributionMutationResult = NonNullable<Awaited<ReturnType<typeof nominateFleetForSupporterContribution>>>
    export type NominateFleetForSupporterContributionMutationBody = SupporterNominationInput
    export type NominateFleetForSupporterContributionMutationError = ErrorType<ValidationError | StandardError>
    export type NominateFleetForSupporterContributionMutationVariables = {id: string;data: SupporterNominationInput}

    /**
 * @summary Nominate the fleet a contribution is for
 */
export const useNominateFleetForSupporterContribution = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof nominateFleetForSupporterContribution>>, TError,NominateFleetForSupporterContributionMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof nominateFleetForSupporterContribution>>,
        TError,
        NominateFleetForSupporterContributionMutationVariables,
        TContext
      > => {
      return useMutation(getNominateFleetForSupporterContributionMutationOptions(options), queryClient);
    }
    /**
 * @summary Show the fleet my donations support
 */
export const mySupportedFleet = (

 signal?: AbortSignal
) => {


      return axiosClient<MySupportedFleet>(
      {url: `/me/supporter/fleet`, method: 'GET', signal
    },
      );
    }




export const getMySupportedFleetQueryKey = () => {
    return [
    'me','supporter','fleet'
    ] as const;
    }


export const getMySupportedFleetQueryOptions = <TData = Awaited<ReturnType<typeof mySupportedFleet>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mySupportedFleet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getMySupportedFleetQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof mySupportedFleet>>> = ({ signal }) => mySupportedFleet(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof mySupportedFleet>>, TError, TData>
}

export type MySupportedFleetQueryResult = NonNullable<Awaited<ReturnType<typeof mySupportedFleet>>>
export type MySupportedFleetQueryError = ErrorType<StandardError>


/**
 * @summary Show the fleet my donations support
 */

export function useMySupportedFleet<TData = Awaited<ReturnType<typeof mySupportedFleet>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof mySupportedFleet>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMySupportedFleetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Choose the fleet my donations support
 */
export const chooseMySupportedFleet = (
    supporterNominationInput: MaybeRefOrGetter<SupporterNominationInput>,
 signal?: AbortSignal
) => {
      supporterNominationInput = toValue(supporterNominationInput);

      return axiosClient<MySupportedFleet>(
      {url: `/me/supporter/fleet`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: supporterNominationInput, signal
    },
      );
    }




export const getChooseMySupportedFleetMutationKey = () => ['chooseMySupportedFleet'] as const;

export const getChooseMySupportedFleetMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chooseMySupportedFleet>>, TError,ChooseMySupportedFleetMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof chooseMySupportedFleet>>, TError,ChooseMySupportedFleetMutationVariables, TContext> => {

const mutationKey = getChooseMySupportedFleetMutationKey();
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof chooseMySupportedFleet>>, ChooseMySupportedFleetMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  chooseMySupportedFleet(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChooseMySupportedFleetMutationResult = NonNullable<Awaited<ReturnType<typeof chooseMySupportedFleet>>>
    export type ChooseMySupportedFleetMutationBody = SupporterNominationInput
    export type ChooseMySupportedFleetMutationError = ErrorType<ValidationError | StandardError>
    export type ChooseMySupportedFleetMutationVariables = {data: SupporterNominationInput}

    /**
 * @summary Choose the fleet my donations support
 */
export const useChooseMySupportedFleet = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof chooseMySupportedFleet>>, TError,ChooseMySupportedFleetMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof chooseMySupportedFleet>>,
        TError,
        ChooseMySupportedFleetMutationVariables,
        TContext
      > => {
      return useMutation(getChooseMySupportedFleetMutationOptions(options), queryClient);
    }
